<template>
	<div>
		<div class="p-3">
			<div class="login-main-sub-container position-relative">
				<div
					class="d-flex align-items-center flex-column text-center internetcheck-page-container"
				>
					<embed
						style="display: none"
						id="pdfEmbed"
						src="../assets/check-upload-speed.pdf"
						width="100%"
						height="500px"
						type="application/pdf"
					/>
					<div class="internetcheck-content-wrapper d-flex h-100 flex-column justify-content-center align-items-center">
						<h1 v-if="!bothFetched" class="fw-500 check-speed-heading">
							Checking your Internet Speed
						</h1>
						<div class="w-100">
							<div
								class="d-flex align-items-center justify-content-around flex-column mt-4 w-100"
							>
								<div
									v-if="!bothFetched"
									class="intspd-cardcontainer intspd-meter-container d-flex flex-column align-items-center justify-content-center p-4"
								>
									<div class="i-guage position-relative mt-4 mb-4">
										<div class="i-guage__body">
											<div class="i-guage__fill"></div>
											<div class="i-guage__cover">
												<img
													:style="`transform: rotate(${angleValue}deg)`"
													class="speedometer-origin"
													id="speed-img"
													src="../../assets/img/internetcheck/speedometerArrow.svg"
													alt=""
												/>
											</div>
										</div>
										<div
											class="position-absolute speedometer-txt"
											style="left: -26px; bottom: -5px"
										>
											0
										</div>
										<div
											class="position-absolute speedometer-txt"
											style="left: -10px; bottom: 47px"
										>
											10
										</div>
										<div
											class="position-absolute speedometer-txt"
											style="top: -20px; left: 26px"
										>
											30
										</div>
										<div
											class="position-absolute speedometer-txt"
											style="top: -37px; right: 84px"
										>
											50
										</div>
										<div
											class="position-absolute speedometer-txt"
											style="top: -20px; right: 18px"
										>
											70
										</div>
										<div
											class="position-absolute speedometer-txt"
											style="right: -18px; bottom: 46px"
										>
											90
										</div>
										<div
											class="position-absolute speedometer-txt"
											style="right: -52px; bottom: -5px"
										>
											100+
										</div>
									</div>

								</div>
								<div
									v-else
									class="intspd-cardcontainer d-flex flex-column align-items-center justify-content-center p-4"
								>
									<div
										class="intspd-main-text d-flex align-items-center justify-content-center"
									>
										<div
											v-if="isNetSpeed"
											class="d-flex align-items-center justify-content-center flex-column"
										>
											<img
												src="../../assets/img/internetcheck/icstable.svg"
												alt=""
												class="my-1"
											/>
											Your internet speed is stable.
											<br />
											Click "Next" to proceed with the test
										</div>
										<div
											v-else
											class="d-flex align-items-center justify-content-center flex-column"
										>
											<img
												src="../../assets/img/internetcheck/warning.svg"
												alt=""
												class="my-1"
											/>
											Due to a slow internet connection, the test
											<br />
											cannot be taken.
										</div>
									</div>
									<div
										v-if="bothFetched"
										class="mt-5 d-flex align-items-center justify-content-center bluebtns"
									>
										<b-button
											v-if="isNetSpeed"
											@click="next()"
											class="w-100px candash-addBtn"
											variant="primary"
											>Next</b-button
										>
										<b-button
											@click="resetAllValues"
											v-else
											class="w-100px candash-addBtn"
											variant="primary "
											>Retry</b-button
										>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SpeedTest from "@cloudflare/speedtest";
import axios from "axios";
import { mapGetters } from "vuex";

// Speed-test endpoints. Use awsmultipart's dedicated /speed/* routes: unlike
// browsertimer, both have `proxy_buffering off` (download) and
// `proxy_request_buffering off` (upload), so the client measures the real
// end-to-end path instead of speed-to-nginx. Overridable per environment so
// the test can be pointed elsewhere without touching component code.
const SPEEDTEST_UPLOAD_URL =
	process.env.VUE_APP_SPEEDTEST_UPLOAD_URL ||
	"https://awsmultipart.hire3x.com/speed/upload/";
const SPEEDTEST_DOWNLOAD_URL =
	process.env.VUE_APP_SPEEDTEST_DOWNLOAD_URL ||
	"https://awsmultipart.hire3x.com/speed/download";

// Measurement parameters. The test runs for DURATION_MS but only the bytes
// transferred after WARMUP_MS count toward the result, so TCP slow-start is
// excluded rather than averaged in.
const SPEEDTEST_DURATION_MS = 10000;
const SPEEDTEST_WARMUP_MS = 2000;
const SPEEDTEST_TIMEOUT_MS = 30000;
const SPEEDTEST_CONNECTIONS = 4;
// 1 MiB chunks amortise per-request/RTT overhead without starving the
// measurement window of samples on slow (single-digit Mbps) uplinks.
const SPEEDTEST_UPLOAD_CHUNK_BYTES = 1024 * 1024;

// Which measurement backend to use:
//   "cloudflare" (default) — measures to the nearest Cloudflare edge; sidesteps
//                            the single-origin RTT/parallelism/HTTP-2 ceiling.
//   "custom"               — the in-house test against the awsmultipart origin.
// Overridable per environment, or per-request via a ?provider= query param
// (handy for A/B in the harness without a rebuild).
const SPEEDTEST_PROVIDER =
	process.env.VUE_APP_SPEEDTEST_PROVIDER || "cloudflare";

// Safety net for a genuine hang; the lean test finishes in ~10s.
const SPEEDTEST_CF_TIMEOUT_MS = 30000;

// Fill a buffer with real random bytes. crypto.getRandomValues rejects
// requests larger than 65536 bytes, so fill in 64 KiB slices.
function fillRandom(buffer) {
	for (let offset = 0; offset < buffer.length; offset += 65536) {
		crypto.getRandomValues(
			buffer.subarray(offset, Math.min(offset + 65536, buffer.length))
		);
	}
	return buffer;
}

export default {
	data() {
		return {
			AllowedMobAndLap: true,
			property: "value",
			angleValue: 45,
			randomInterval: null,
			downloadFetched: false,
			uploadFetched: false,
			bothFetched: false,
			downloadSpeed: 0,
			speed: 0,
			uploadSpeed: 0,
			checkupfinish: false,
			analyzeUpload: null,
			analyzedownload: null,
		};
	},
	async mounted() {

		localStorage.clear();
		this.randomInterval = setInterval(() => {
			this.randomizeAngle();
		}, 500);
		try {
			await this.runSpeedTests();
		} catch (error) {
			console.warn("Speed tests encountered an error or were aborted.", error);
		}

		this.bothFetched = true;
		this.checkupfinish = true;
		clearInterval(this.randomInterval);
	},

	computed: {
		speedToDegree() {
			return Math.round(this.downloadSpeed * 1.8) - 45;
		},
		progressBarStyle() {
			return {
				background: `conic-gradient(
            #4c78ce ${10 * 3.6}deg,
            #fff ${10 * 3.6}deg
          )`,
			};
		},
		isNetSpeed() {
			return this.downloadSpeed >= 3 && this.uploadSpeed >= 3;
		},
		rotation() {
			return this.value * 3.6; // Convert percentage to degrees (1% = 3.6deg)
		},
	},

	methods: {
		// Drives SPEEDTEST_CONNECTIONS parallel workers for SPEEDTEST_DURATION_MS.
		// `transferOnce(signal)` performs one chunk transfer and resolves with the
		// number of bytes moved. Returns the throughput in Mbps.
		//
		// Only chunks that *start* after the warm-up boundary count, and the result
		// is bytes / (window duration) over that same window — so bytes and time
		// always refer to the same interval. (The old code divided completed-chunk
		// bytes by wall-clock time that ran on until the last in-flight request
		// resolved, which biased the number low.)
		async runSpeedTest(transferOnce, label) {
			const startTime = performance.now();
			let totalBytes = 0; // everything, for the slow-link fallback
			let measuredBytes = 0; // post-warm-up only
			let measureStart = null;
			let measureEnd = null;
			let completed = 0;
			let failed = 0;

			const controller = new AbortController();
			const timeoutId = setTimeout(() => {
				controller.abort();
				console.warn(`${label} test aborted due to timeout.`);
			}, SPEEDTEST_TIMEOUT_MS);

			const worker = async () => {
				while (performance.now() - startTime < SPEEDTEST_DURATION_MS) {
					const chunkStart = performance.now();
					let bytes;
					try {
						bytes = await transferOnce(controller.signal);
					} catch (error) {
						if (axios.isCancel(error) || error.name === "CanceledError") {
							break; // real abort (timeout) — stop this worker
						}
						// Transient failure: keep the worker alive so we don't
						// silently lose 1/N of capacity. Small backoff so a hard
						// failure can't busy-spin for the whole window.
						failed++;
						await new Promise((r) => setTimeout(r, 50));
						continue;
					}
					completed++;
					totalBytes += bytes;
					if (chunkStart - startTime >= SPEEDTEST_WARMUP_MS) {
						// earliest start across all workers, so the window isn't
						// under-counted when a later-starting chunk finishes first
						if (measureStart === null || chunkStart < measureStart) {
							measureStart = chunkStart;
						}
						measuredBytes += bytes;
						measureEnd = performance.now();
					}
				}
			};

			await Promise.all(
				Array(SPEEDTEST_CONNECTIONS).fill(null).map(worker)
			);
			clearTimeout(timeoutId);

			if (failed > 0) {
				console.warn(`${label}: ${failed} request(s) failed of ${completed + failed}.`);
			}

			// Preferred: throughput over the measurement window.
			if (measureStart !== null && measureEnd > measureStart) {
				const seconds = (measureEnd - measureStart) / 1000;
				return (measuredBytes * 8) / seconds / (1024 * 1024);
			}
			// Fallback (link too slow for any chunk to complete after warm-up):
			// use the whole run so we still report a real number, not 0.
			const seconds = (performance.now() - startTime) / 1000;
			return seconds > 0 ? (totalBytes * 8) / seconds / (1024 * 1024) : 0;
		},

		async checkDownloadSpeed() {
			const fileUrl = SPEEDTEST_DOWNLOAD_URL;
			const mbps = await this.runSpeedTest(async (signal) => {
				const response = await axios.get(fileUrl, {
					responseType: "arraybuffer",
					signal,
					headers: { "Cache-Control": "no-cache" },
				});
				return response.data.byteLength;
			}, "Download");

			this.downloadSpeed = Math.round(mbps);
			this.downloadFetched = true;
		},

		next() {
			this.$emit("internet-checked");
		},
		async resetAllValues() {
			this.downloadFetched = false;
			this.uploadFetched = false;
			this.downloadFetched = false;
			// this.connectionSlow = false;
			this.bothFetched = false;
			this.downloadSpeed = 0;
			this.uploadSpeed = 0;
			this.randomInterval = setInterval(() => {
				this.randomizeAngle();
			}, 2000);
			try {
				await this.runSpeedTests();
			} catch (error) {
				console.warn(
					"Speed tests encountered an error or were aborted.",
					error
				);
			}
			this.bothFetched = true;
			this.checkupfinish = true;
			clearInterval(this.randomInterval);
			// this.uploadNewChunk();
		},
		randomizeAngle() {
			this.angleValue = Math.floor(Math.random() * 201) - 100;
		},
		// Dispatch to the configured backend. ?provider= wins over the build-time
		// env default so the two can be A/B'd in one build.
		async runSpeedTests() {
			const provider =
				(this.$route && this.$route.query && this.$route.query.provider) ||
				SPEEDTEST_PROVIDER;
			if (provider === "custom") {
				await this.runCustomTest();
				return;
			}
			// Cloudflare edge test (default), with a fail-open fallback.
			const ok = await this.checkSpeedCloudflare();
			if (!ok) {
				// Fail open: never block a candidate because Cloudflare failed or got
				// rate-limited. Fall back to the in-house test.
				console.warn(
					"Cloudflare speed test unavailable; falling back to the in-house test."
				);
				this.downloadFetched = false;
				this.uploadFetched = false;
				await this.runCustomTest();
			}
		},

		// In-house sequential test (browser -> awsmultipart origin).
		async runCustomTest() {
			await this.checkDownloadSpeed();
			await this.checkUploadSpeed();
		},

		// Resolves true only if both download and upload measured, else false so
		// the caller can fall back. Cloudflare reports bits/s; /1e6 -> Mbps.
		async checkSpeedCloudflare() {
			return await new Promise((resolve) => {
				let settled = false;
				let timer = null;
				const finish = (success) => {
					if (settled) return;
					settled = true;
					if (timer) clearTimeout(timer);
					resolve(success);
				};

				const engine = new SpeedTest({
					autoStart: false,
					// Don't ship candidate results to Cloudflare's AIM logging endpoint.
					logAimApiUrl: null,
					// Pass/fail only, so cap at 1 MB chunks: a ~10 Mbps link finishes
					// each request in ~1s rather than ~8s on a 10 MB chunk. No packetLoss
					// (TURN can hang on locked-down networks).
					measurements: [
						{ type: "latency", numPackets: 1 },
						{ type: "download", bytes: 1e5, count: 1, bypassMinDuration: true },
						{ type: "download", bytes: 5e5, count: 3 },
						{ type: "download", bytes: 1e6, count: 4 },
						{ type: "upload", bytes: 1e5, count: 2, bypassMinDuration: true },
						{ type: "upload", bytes: 5e5, count: 3 },
						{ type: "upload", bytes: 1e6, count: 4 },
					],
				});

				const applySummary = () => {
					const s = engine.results.getSummary();
					if (typeof s.download === "number") {
						this.downloadSpeed = Math.round(s.download / 1e6);
						this.downloadFetched = true;
					}
					if (typeof s.upload === "number") {
						this.uploadSpeed = (s.upload / 1e6).toFixed(2);
						this.uploadFetched = true;
					}
				};

				engine.onResultsChange = () => applySummary();
				engine.onFinish = () => {
					applySummary();
					const s = engine.results.getSummary();
					// Fall back unless both legs measured — a missing upload would
					// otherwise read 0 and trip the gate.
					finish(
						typeof s.download === "number" && typeof s.upload === "number"
					);
				};
				engine.onError = (message) => {
					console.error("Cloudflare speed test error:", message);
					finish(false);
				};

				// Safety net: if the engine stalls (blocked network, edge issue),
				// don't leave the candidate waiting — bail and let the caller fall back.
				timer = setTimeout(() => {
					try {
						engine.pause();
					} catch (e) {
						/* pause may be unavailable depending on the current phase */
					}
					console.warn("Cloudflare speed test timed out; will fall back.");
					finish(false);
				}, SPEEDTEST_CF_TIMEOUT_MS);

				engine.play();
			});
		},
		async checkUploadSpeed() {
			const sizeInBytes = SPEEDTEST_UPLOAD_CHUNK_BYTES;
			// Real random bytes, not a zero-filled buffer. Harmless with today's
			// endpoints, but a proxy that compresses request bodies would report a
			// fake (inflated) speed for an all-zero payload.
			const randomData = fillRandom(new Uint8Array(sizeInBytes));

			const mbps = await this.runSpeedTest(async (signal) => {
				const formData = new FormData();
				formData.append("file", new Blob([randomData]));
				await axios.post(SPEEDTEST_UPLOAD_URL, formData, { signal });
				return sizeInBytes;
			}, "Upload");

			this.uploadSpeed = mbps.toFixed(2);
			this.uploadFetched = true;
		},
	},
};
</script>
<style>
.internetcheck-page-container {
	border-radius: 14px;
	background: url("../../assets/img/internetcheck/internetcheck.png");
	background-repeat: no-repeat;
	background-size: cover;
	padding: 30px;
	height: calc(100vh - 92px);
	width: 100%;
	overflow: auto;
}

@media only screen and (max-width: 1024px) {
	.check-speed-heading {
		font-size: 22px !important;
	}
	.internetcheck-page-container {
		padding: 15px !important;
	}
	.intspd-meter-container {
		background: transparent !important;
		box-shadow: none !important;
	}
	.intspd-cardcontainer {
		height: 290px !important;
	}
	.i-guage {
		transform: scale(1.15) !important;
	}
	.internetcheck-page-container{
		height: calc(100dvh - 90px) !important;
		overflow: hidden !important;
	}
}
@media only screen and (min-width: 1024px) {
	.screenSizeMobile {
		display: none;
	}
}

.intspd-cardcontainer {
	border-radius: 14px;
	background: #fff;
	box-shadow: 0px 15px 30px 0px rgba(122, 122, 122, 0.2);
	width: 100%;
	max-width: 590px;
	height: 340px;
}

.intspd-main-text {
	/* Due to a slow internet connection, the test cannot be taken. */

	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 22px;
	text-align: center;

	color: #636363;
}

.i-guage {
	border: 8.107px solid #f5eeee;
	border-bottom: none;
	border-top-left-radius: 100% 200%;

	border-top-right-radius: 100% 200%;
	width: 100%;
	max-width: 200px;
	/* scale() keeps the arc and its px-positioned labels aligned (max-width won't) */
	transform: scale(1.25);
}

.i-guage__body {
	width: 100%;
	height: 0;
	padding-bottom: 50%;
	background: #b4b4b4;
	position: relative;
	border-top-left-radius: 100% 200%;
	border-top-right-radius: 100% 200%;
	overflow: hidden;
}

.i-guage__fill {
	background: #4c78ce;
	position: absolute;
	top: 100%;
	left: 0;
	width: inherit;
	height: 100%;

	transform-origin: center top;
	transform: rotate(0.5turn);
	transition: transform 0.2s ease-out;
}

.i-guage__cover {
	border: 8.107px solid #f5eeee;
	background: white;
	width: 94%;
	height: 187%;
	border-radius: 50%;
	position: absolute;
	top: 7%;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	padding-bottom: 25%;
}

.speedometer-origin {
	transform-origin: 50% 70%;
	transition: 0.5s all linear;
}

.speedometer-txt {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	color: #696969;
}

.check-speed-heading {
	color: #333333;
	font-family: "Lato", sans-serif;
	font-size: 30px;
	font-style: normal;
}

.internetcheck-content-wrapper {
	width: 75%;
}
@media only screen and (max-width: 768px) {
	.internetcheck-content-wrapper {
		width: 100%;
	}
}
</style>
